module.exports = __webpack_public_path__ + "img/main_3_3_1.7b0d972d.png";